import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

import Place from './Place';

import styles from './Type.module.scss';

export default class Type extends React.Component {
  renderPlaceInfo(places) {
    if (isEmpty(places)) return <div />;

    return places.map(p => {
      return (
        <Place
          key={'mtePlaceKey' + p.order}
          place={cloneDeep(p || {})}
          placeNumber={p.order + 1}
          onSwapPlacesFunc={this.props.onSwapPlacesFunc}
          highlightDestinationFunc={this.props.highlightDestinationFunc}
          highlight={this.props.highlight}
        />
      );
    });
  }

  render() {
    const { type, places } = cloneDeep(this.props);
    const { name = '' } = type;

    return (
      <div className={styles.root} onClick={this.props.onSelectTypeFunc}>
        {' '}
        <span style={{ margin: 'auto' }}>{name}</span>
        {this.renderPlaceInfo(places)}
      </div>
    );
  }
}
